import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import { useState } from "react";
import EquipmentForm from "../../components/ui/equipmentForm/equipmentForm.component";
import EquipmentCounterForm from "../../components/ui/equipmentCounterForm/equipmentCounterForm.component";
import { useHasPermission } from "../../contexts/auth";

export const EquipmentsActions = () => {
  const { t } = useTranslation();
  const [addEquipmentOpened, setAddEquipmentOpened] = useState<boolean>(false);
  const [addCounterOpened, setAddCounterOpened] = useState<boolean>(false);
  const canAddEquipment = useHasPermission("settlement.add_equipment");
  const canAddCounter = useHasPermission("settlement.add_equipmentcounter");

  const actions: Action[] = [
    {
      id: "add-new-equipment",
      icon: <AddIcon />,
      label: t("Add new equipment"),
      onClick: () => { setAddEquipmentOpened(true); },
      disabled: !canAddEquipment,
    },
    {
      id: "add-new-counter",
      icon: <AddIcon />,
      label: t("Add new counter"),
      onClick: () => { setAddCounterOpened(true); },
      disabled: !canAddCounter,
    },
  ];

  const handleEquipmentAdded = () => {
    setAddEquipmentOpened(false);
    window.dispatchEvent(new Event('equipmentAdded'));
  };

  const handleCounterAdded = () => {
    setAddCounterOpened(false);
    window.dispatchEvent(new Event("equipmentCounterAdded"));
  };

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={addEquipmentOpened}
        setOpened={setAddEquipmentOpened}
        title={t("Add new equipment")}
        content={
          <EquipmentForm
            onSuccess={handleEquipmentAdded}
          />
        }
      />
      <CustomModal
        opened={addCounterOpened}
        setOpened={setAddCounterOpened}
        title={t("Add new counter")}
        content={
          <EquipmentCounterForm
            onSuccess={handleCounterAdded}
            hiddenFields={["job"]}
          />
        }
      />
    </>
  );
};
